import React from 'react'
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineDot from '@material-ui/lab/TimelineDot';

import {useStyles} from './styles'

const HeaderTimeline = ({icon}) => {
    const classes = useStyles();
    return (
        <TimelineItem className={classes.timeline_firstItem}>
        <TimelineSeparator>
          <TimelineDot className={classes.timeline_dot_header}>{icon}</TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
      </TimelineItem>
    )
}

export default HeaderTimeline
